<script>
import Modal from './Modal.vue';
import { isQueryParamTrue } from '../js/common.js'
import { areAllRolesSelected } from '../common/common';

const DROPDOWN_KEYS = Object.freeze({
  ROLES: "roles",
  TAGS: "tags",
  ETC: "etc",
})

export default {
  props: {
    modalName: String,
    companyID: Number,
    tags: Array,
    roles: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      isVisible: false,
      isLoading: false,
      popUp: null,
      checkedRoles: [],
      checkedTags: [],
      workerOnly: isQueryParamTrue("workerOnly"),
      lockedOnly: isQueryParamTrue("lockedOnly"),
      dropDownState: {
        roles: true,
        tags: true,
        etc: true,
      }
    }
  },
  components: {
    Modal,
  },
  methods: {
    closeModal() {
      this.isVisible = false;
    },
    openModal() {
      this.isVisible = true;
    },
    onConfirm() {
      if (this.isLoading) {
        return;
      }
      this.isLoading = true;
      const param = {
        list: GetURLParam("list"),
        date: GetURLParam("date"),
        tags: this.checkedTags.join(","),
        // The backend interprets "all" as all role-assigned slots.
        // An empty selection intentionally remains the unfiltered/all-slots state.
        roles: this.isRoleSelectedAll ? "all" : this.checkedRoles.join(","),
        workerOnly: this.workerOnly,
        lockedOnly: this.lockedOnly,
        c: this.companyID,
      };

      const until = GetURLParam("until");
      if (until.length > 0) {
        param.until = until;
      }

      const url = window.location.origin + window.location.pathname;
      window.location = url + "?" + $.param(param);
    },
    onCancel() {
      this.isVisible = false;
    },
    clearFilter() {
      this.checkedRoles = [];
      this.checkedTags = [];
      this.lockedOnly = false;
      this.workerOnly = false;
    },
    // Note: tags and roles props have different data structures, resulting in different initialization logic.
    // roles are an array of role objects; tags are an array of selectable tag objects.
    // tags are an array of objects: [tag1: {selected: bool, tag: string, decodedTag: string}, tag2: {selected: bool, tag: string2, decodedTag: string}]
    getSelectedRoles() {
      if (GetURLParam("roles") === "all") {
        this.checkedRoles = this.filterRoles.map(role => role.ID);
        return;
      }

      const selecteRoleIDStr = GetURLParam("roles");
      if (selecteRoleIDStr) {
        return this.checkedRoles = selecteRoleIDStr
          .split(",")
          .filter(Boolean)
          .map(Number)
          .filter(id => Number.isFinite(id) && id > 0);
      } else {
        this.checkedRoles = []
      }
    },
    getSelectedTags() {
      if (this.tags) {
        this.tags.forEach(tagObj => {
          if (tagObj.selected) {
            this.checkedTags.push(tagObj.tag);
          }
        })
      }
    },
    initSelectedData() {
      this.getSelectedRoles();
      this.getSelectedTags();
    },
    confirmFilter() {
      if (this.isLoading) {
        return;
      }
      this.isLoading = true;
      const param = {
        list: GetURLParam("list"),
        date: GetURLParam("date"),
        tags: this.checkedTags.join(","),
        roles: this.checkedRoles.join(","),
        workerOnly: this.workerOnly,
        lockedOnly: this.lockedOnly,
        c: this.companyID,
      };

      const until = GetURLParam("until");
      if (until.length > 0) {
        param.until = until;
      }

      const area = GetURLParam("area");
      if (area.length > 0) {
        param.area = area;
      }

      const url = window.location.origin + window.location.pathname;
      window.location = url + "?" + $.param(param);
    },
    setRoleDropDownState() {
      window.sessionStorage.setItem("dropDownState", JSON.stringify(this.dropDownState))
    },
    getDropDownState() {
      const state = window.sessionStorage.getItem("dropDownState");
      if (!state) {
        return
      }
      this.dropDownState = JSON.parse(state);
    },
    handleDropDown(event, keyVal) {
      this.dropDownState[keyVal] = event.currentTarget.checked;
      this.setRoleDropDownState();
    },
    handleRolesDropDown(event) {
      this.handleDropDown(event, DROPDOWN_KEYS.ROLES)
    },
    handleTagsDropDown(event) {
      this.handleDropDown(event, DROPDOWN_KEYS.TAGS)
    },
    handleEtcDropDown(event) {
      this.handleDropDown(event, DROPDOWN_KEYS.ETC)
    },
    resetPopupState() {
      this.popUp = null;
    },
    setPopup(id) {
      this.popUp = id;
    },
    showPopup(id) {
      return this.popUp === id;
    },
    setRoleColor(role) {
      if (!role?.Color) {
        return;
      }
      return {
        backgroundColor:`#${role.Color}`,
        color: '#fff'
      }
    },
    handleSelectAll(event) {
      if (event.target.checked) {
        this.checkedRoles = this.filterRoles.map(r => r.ID);
      } else {
        this.checkedRoles = []
      }
    },
  },
  computed: {
    hasTags() {
      return Boolean(this.tags?.length);
    },
    hasRoles() {
      return this.filterRoles.length > 0;
    },
    loadingClass() {
      return this.isLoading ? "loading" : "";
    },
    hasAnyActiveFilters() {
      return (this.checkedRoles.length > 0 && !this.isRoleSelectedAll)
        || this.checkedTags.length
        || this.workerOnly
        || this.lockedOnly;
    },
    filterRoles() {
      return this.roles.filter(r => !r.IsRoleSection);
    },
    isRoleSelectedAll() {
      return areAllRolesSelected(this.filterRoles, this.checkedRoles);
    }
  },
  created() {
    this.initSelectedData();
  },
  mounted() {
    this.getDropDownState();
  }
}
</script>

<template>
  <Modal :modal-name="modalName" v-if="isVisible" @closeModal="closeModal" @confirm="onConfirm" @cancel="onCancel" :has-title-divider="true" :has-footer-divider="true">
    <template v-slot:header-title>
        フィルター
    </template>
    <template v-slot:content>
      <div class="content-wrapper">
        <!-- Roles -->
        <div v-if="hasRoles" class="roles-filter">

          <div class="accordion">
            <input type="checkbox" id="role-filter-accordion" name="accordion-checkbox" hidden @change="handleRolesDropDown" :checked="dropDownState.roles">
            <div class="accordion-header filter-title-wrapper">
              <label class="role-accordion-title" for="role-filter-accordion">
                <i class="icon icon-arrow-right mr-1"></i>
                <span class="filter-title">業務</span>
              </label>
              <div class="role-staff-input-wrapper">
                <label class="oplus-form-checkbox">
                  <input type="checkbox" @change="handleSelectAll" :checked="isRoleSelectedAll" />
                  全て
                </label>
              </div>
            </div>
            <div class="accordion-body">
              <div class="filter-wrapper">
                <div v-for="role in filterRoles" :key="role.ID">
                  <label @click="setPopup(role.ID)" @mouseleave="resetPopupState()" class="oplus-form-checkbox" :data-role="role.ID">
                    <input :value="role.ID" v-model="checkedRoles" class="filter-checkbox text-popup" type="checkbox">
                    <span class="role-name role-name-filter" :style="setRoleColor(role)">{{ role.Name }}</span>
                    <transition name="fade">
                      <span v-show="showPopup(role.ID)" class="filter-text-popup">{{ role.Name }}</span>
                    </transition>
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-divider"></div>
        </div>

        <!-- Tags -->
        <div v-if="hasTags" class="tags-filter">
          <div class="accordion">
            <input type="checkbox" id="tags-filter-accordion" name="accordion-checkbox" hidden @change="handleTagsDropDown" :checked="dropDownState.tags">
            <label class="accordion-header filter-title-wrapper" for="tags-filter-accordion">
              <i class="icon icon-arrow-right mr-1"></i>
              <span class="filter-title">タグ</span>
            </label>
            <div class="accordion-body">
              <div class="filter-wrapper">
                <div v-for="tag in tags" :key="tag">
                  <label class="oplus-form-checkbox" :data-tag="tag.tag"  @click="setPopup(tag.tag)" @mouseleave="resetPopupState()">
                    <input :value="tag.tag" v-model="checkedTags" class="filter-checkbox" type="checkbox">
                    <span class="filter-name">{{ tag.decodedTag }}</span>
                    <transition name="fade">
                      <span v-show="showPopup(tag.tag)" class="filter-text-popup">{{ tag.decodedTag }}</span>
                    </transition>
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-divider"></div>
        </div>

        <!-- Etc. (worker and locked only options) -->
        <div class="etc-filter">
          <div class="accordion">
            <input type="checkbox" id="etc-filter-accordion" name="accordion-checkbox" hidden @change="handleEtcDropDown" :checked="dropDownState.etc">
            <label class="accordion-header filter-title-wrapper" for="etc-filter-accordion">
              <i class="icon icon-arrow-right mr-1"></i>
              <span class="filter-title">その他</span>
            </label>
            <div class="accordion-body">
              <div class="filter-wrapper">
                <div>
                  <label class="oplus-form-checkbox">
                    <input class="filter-checkbox" type="checkbox" v-model="workerOnly">
                    出勤者のみ
                  </label>
                </div>
                <div>
                  <label class="oplus-form-checkbox">
                    <input class="filter-checkbox" type="checkbox" v-model="lockedOnly">
                    確定のみ
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
    <template v-slot:footer-btn>
      <div class="btn-wrapper">
        <button class="oplus-modal-btn oplus-cancel-btn"  @click="clearFilter">クリア</button>
        <button :class="loadingClass" class="oplus-modal-btn oplus-alt-confirm-btn"  @click="onConfirm">確定</button>
      </div>
    </template>
  </Modal>
</template>

<style scoped>
  .accordion-header.filter-title-wrapper {
    display: flex;
    align-items: center;
    width: fit-content;
    gap: 20px;
  }

  .role-accordion-title {
    display: flex;
    align-items: center;
  }

  .role-name-filter {
    font-size: 0.8rem
  }

  .header-wrapper {
    text-align: center;
    padding-bottom: 0;
  }
  .content-wrapper {
    display: flex;
    width: fit-content;
    min-width: 600px;
    flex-direction: column;
    text-align: center;
    gap: 10px;
    height: fit-content;
    padding: 20px 0;
  }

  .filter-title {
    text-align: left;
    font-size: 1rem;
    display: flex;
    align-items: center;
    gap: 20px;
  }

  .filter-name {
    max-width: 140px;
    width: fit-content;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .filter-wrapper {
    display: grid;
    max-width: 100%;
    grid-template-columns: repeat(auto-fill, minmax(168px,1fr));
    text-align: left;
    padding: 20px 10px;
    gap: 20px;
  }

  .filter-wrapper.etc-wrapper {
    padding-bottom: 0;
  }

  .roles-filter, .tags-filter, .etc-filter {
    display: flex;
    flex-direction: column;
  }

  .modal-divider {
    border: 0;
    width: 100%;
    border-top: 1px solid #cfcfcf;
  }

  .btn-wrapper {
    display: flex;
    justify-content: space-between;
  }

  .filter-text-popup {
    position: absolute;
    right: 0%;
    bottom: -80%;
    background: rgba(48,55,66,.95);
    border-radius: .1rem;
    color: #fff;
    font-size: .7rem;
    padding: .2rem .4rem;
    pointer-events: none;
    z-index: 300;
    max-width: 200px;
    height: fit-content;
    white-space: break-spaces;
    word-wrap: break-word;
  }

  .oplus-form-checkbox {
    position: relative;
  }

  .fade-enter-active, .fade-leave-active {
    transition: opacity 0.2s;
  }
  .fade-enter, .fade-leave-to {
    opacity: 0;
  }

  @media (max-width: 600px) {
    .content-wrapper {
      min-width: 90vw;
    }
  }

  @media (max-width: 392px) {
    .filter-name {
      max-width: 280px;
    }
  }

</style>
